import { CloseCircleFilled } from '@ant-design/icons'
import { Progress, Image } from 'antd'
import { useState, useEffect } from 'react'
import { GenericFileCard } from '../FileCard'
import styles from './style.module.less'
import deleteIcon from '@/assets/icon/icon／close@2x.png'
// --- 主组件 ---
interface FileCardProps {
  file: {
    id: string
    name: string
    size: number
    type: string
    url?: string
    originFileObj?: File
  }
  onDelete?: () => void
}

const InputFileCard = ({ file, onDelete }: FileCardProps) => {
  const [percent, setPercent] = useState(0)
  const [showProgress, setShowProgress] = useState(true)

  // 模拟 3s 进度条
  useEffect(() => {
    const duration = 3000 // 3秒
    const interval = 30 // 刷新频率
    const step = 100 / (duration / interval)

    const timer = setInterval(() => {
      setPercent((prev) => {
        if (prev >= 100) {
          clearInterval(timer)
          setTimeout(() => setShowProgress(false), 400) // 满格后稍微停顿再消失
          return 100
        }
        return prev + step
      })
    }, interval)

    return () => clearInterval(timer)
  }, [])

  const isImage =
    file.type.startsWith('image/') ||
    /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name)

  return (
    <div className={styles.fileCardContainer}>
      {/* 删除按钮 */}
      {onDelete && <img src={deleteIcon} className={styles.deleteBtn} onClick={onDelete} />}

      {/* 内容区域 */}
      {isImage ? (
        <div className={styles.imageWrapper}>
          <Image
            src={
              file.url ||
              (file.originFileObj
                ? URL.createObjectURL(file.originFileObj)
                : '')
            }
            width={54}
            alt={file.name}
            preview={{ mask: '' }}
          />
        </div>
      ) : (
        <GenericFileCard name={file.name} size={file.size} type={file.type} status={file.status} />
      )}

      {/* 模拟进度条 */}
      {showProgress && (
        <div className={styles.progressWrap}>
          <Progress
            percent={percent}
            showInfo={false}
            strokeWidth={2}
            strokeColor="#1677ff"
            trailColor="transparent"
          />
        </div>
      )}
    </div>
  )
}

export default InputFileCard
